import { useState } from "react";
import { faqs } from "@/mocks/homeData";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-100 py-14 md:py-20 lg:py-24">
      <div className="px-4 md:px-6 lg:px-10 max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-wider text-accent-500 border border-accent-200 rounded-full px-3 py-1 mb-3">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Frequently Asked{" "}
            <span className="text-primary-500">Questions</span>
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-xl mx-auto">
            Common questions about fire safety compliance, assessments, and our services in Singapore.
          </p>
        </div>

        {/* FAQ Items */}
        <div className="flex flex-col gap-3 md:gap-4">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                aria-expanded={openIndex === index}
              >
                <span className="font-semibold text-foreground-900 text-sm md:text-base pr-4">
                  {faq.question}
                </span>
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-primary-600 text-lg transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}